import React from 'react';
import CTAButton from './CTAButton';
export function BenefitsSection() {
  return <section className="py-6 px-4 bg-gradient-to-b from-green-50 to-white" data-id="element-12">
      <div className="max-w-4xl mx-auto" data-id="element-13">
        <h2 className="text-3xl md:text-5xl font-black text-green-600 mb-6 text-center" data-id="element-14">
          🔥 LO QUE TU HIJO VA A LOGRAR
        </h2>

        <div className="bg-white p-5 rounded-lg shadow-lg mb-4" data-id="element-15">
          <ul className="space-y-3" data-id="element-16">
            <li className="flex items-start" data-id="element-17">
              <span className="text-green-600 font-bold text-2xl mr-4" data-id="element-18">✔</span>
              <span className="text-xl" data-id="element-19">Entender el dinero desde pequeño</span>
            </li>
            <li className="flex items-start" data-id="element-20">
              <span className="text-green-600 font-bold text-2xl mr-4" data-id="element-21">✔</span>
              <span className="text-xl" data-id="element-22">Ahorrar sin que se lo digas</span>
            </li>
            <li className="flex items-start" data-id="element-23">
              <span className="text-green-600 font-bold text-2xl mr-4" data-id="element-24">✔</span>
              <span className="text-xl" data-id="element-25">Pensar antes de gastar</span>
            </li>
            <li className="flex items-start" data-id="element-26">
              <span className="text-green-600 font-bold text-2xl mr-4" data-id="element-27">✔</span>
              <span className="text-xl" data-id="element-28">Crear ideas para generar dinero</span>
            </li>
            <li className="flex items-start" data-id="element-29">
              <span className="text-green-600 font-bold text-2xl mr-4" data-id="element-30">✔</span>
              <span className="text-xl" data-id="element-31">Desarrollar disciplina</span>
            </li>
            <li className="flex items-start" data-id="element-32">
              <span className="text-green-600 font-bold text-2xl mr-4" data-id="element-33">✔</span>
              <span className="text-xl" data-id="element-34">Tener mentalidad de crecimiento</span>
            </li>
          </ul>
        </div>

        <div className="bg-white p-5 rounded-lg shadow-lg mb-4" data-id="element-35">
          <h3 className="text-2xl md:text-4xl font-black text-gray-800 mb-3" data-id="element-36">
            🧩 ¿POR QUÉ ESTE PROGRAMA FUNCIONA?
          </h3>
          <p className="text-xl mb-3" data-id="element-37">Porque no enseña solo dinero…</p>
          <ul className="space-y-2" data-id="element-38">
            <li className="flex items-start" data-id="element-39">
              <span className="text-blue-600 font-bold mr-3" data-id="element-40">👉</span>
              <span className="text-xl" data-id="element-41">Enseña comportamiento</span>
            </li>
            <li className="flex items-start" data-id="element-42">
              <span className="text-blue-600 font-bold mr-3" data-id="element-43">👉</span>
              <span className="text-xl" data-id="element-44">Enseña hábitos</span>
            </li>
            <li className="flex items-start" data-id="element-45">
              <span className="text-blue-600 font-bold mr-3" data-id="element-46">👉</span>
              <span className="text-xl" data-id="element-47">Enseña mentalidad</span>
            </li>
          </ul>
        </div>

        <div className="bg-gradient-to-r from-blue-500 to-purple-600 p-5 rounded-lg shadow-lg mb-4" data-id="element-48">
          <h3 className="text-2xl md:text-4xl font-black text-white mb-3" data-id="element-49">
            🧠 IMAGINA ESTO…
          </h3>
          <p className="text-xl text-white mb-2" data-id="element-50">Tu hijo:</p>
          <ul className="space-y-2" data-id="element-51">
            <li className="flex items-start" data-id="element-52">
              <span className="text-yellow-300 font-bold text-2xl mr-4" data-id="element-53">
                ✔
              </span>
              <span className="text-xl text-white" data-id="element-54">
                Sabe qué hacer con su dinero
              </span>
            </li>
            <li className="flex items-start" data-id="element-55">
              <span className="text-yellow-300 font-bold text-2xl mr-4" data-id="element-56">
                ✔
              </span>
              <span className="text-xl text-white" data-id="element-57">Tiene metas</span>
            </li>
            <li className="flex items-start" data-id="element-58">
              <span className="text-yellow-300 font-bold text-2xl mr-4" data-id="element-59">
                ✔
              </span>
              <span className="text-xl text-white" data-id="element-60">No compra por impulso</span>
            </li>
            <li className="flex items-start" data-id="element-61">
              <span className="text-yellow-300 font-bold text-2xl mr-4" data-id="element-62">
                ✔
              </span>
              <span className="text-xl text-white" data-id="element-63">Piensa antes de actuar</span>
            </li>
            <li className="flex items-start" data-id="element-64">
              <span className="text-yellow-300 font-bold text-2xl mr-4" data-id="element-65">
                ✔
              </span>
              <span className="text-xl text-white" data-id="element-66">Genera ideas</span>
            </li>
          </ul>
          <p className="text-xl text-white font-bold mt-3" data-id="element-67">
            👉 Eso no lo enseña la escuela.
          </p>
        </div>

        <div className="bg-red-50 p-5 rounded-lg shadow-lg mb-4" data-id="element-68">
          <h3 className="text-2xl md:text-4xl font-black text-red-600 mb-3" data-id="element-69">
            ⚠️ SI NO HACES NADA…
          </h3>
          <p className="text-xl mb-2" data-id="element-70">Tu hijo crecerá como la mayoría:</p>
          <ul className="space-y-2" data-id="element-71">
            <li className="flex items-start" data-id="element-72">
              <span className="text-red-600 font-bold mr-3" data-id="element-73">❌</span>
              <span className="text-lg" data-id="element-74">Sin educación financiera</span>
            </li>
            <li className="flex items-start" data-id="element-75">
              <span className="text-red-600 font-bold mr-3" data-id="element-76">❌</span>
              <span className="text-lg" data-id="element-77">Repitiendo errores</span>
            </li>
            <li className="flex items-start" data-id="element-78">
              <span className="text-red-600 font-bold mr-3" data-id="element-79">❌</span>
              <span className="text-lg" data-id="element-80">
                Viviendo con frustración económica
              </span>
            </li>
          </ul>
        </div>

        <div className="bg-green-50 p-5 rounded-lg shadow-lg mb-4" data-id="element-81">
          <h3 className="text-2xl md:text-4xl font-black text-green-600 mb-3" data-id="element-82">
            💡 PERO SI ACTÚAS HOY…
          </h3>
          <p className="text-2xl font-bold" data-id="element-83">
            Le das una ventaja para toda la vida.
          </p>
        </div>

        <CTAButton text="¡QUIERO DARLE ESA VENTAJA A MI HIJO!" data-id="element-84" />
      </div>
    </section>;
}
export default BenefitsSection;